var map = {
	"./Hunter.png": 5261,
	"./IceCream.png": 8966,
	"./Jet.png": 2698,
	"./Macadamia.png": 2805,
	"./Mizzle.png": 348,
	"./Orange.png": 5481,
	"./Plata.png": 2967,
	"./Sage.png": 4943,
	"./Sandstone.png": 5898,
	"./Sisal.png": 7603,
	"./Smog.png": 4793,
	"./Sunkist.png": 4552,
	"./Umber.png": 9206,
	"./Whale.png": 880,
	"./White.png": 8112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1310;